import React, { Component } from 'react';
import classNames from 'classnames';
import { Screen, Tap} from 'dooh-react-utils';
import styled from 'styled-components';
import Timer from './Timer';

import card1 from './cards/1.png';
import card2 from './cards/2.png';
import card3 from './cards/3.png';
import card4 from './cards/4.png';
import card5 from './cards/5.png';
import card6 from './cards/6.png';
import backCard from './cards/back.png';

const CARDS = [backCard, card1, card2, card3, card4, card5, card6];

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const CardWrapper = styled.div`
  width: ${({width}) => width};
  height: ${({height}) => height};
  margin: ${({margin}) => margin};
  cursor: pointer;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 1s;

  &.selected {
    transform: rotateY(180deg);
  }

  &.discovered {
    transform: rotateY(180deg);
  }

  & > div {
    background: rgba(0, 0, 0, 0);
    position: absolute;
    backface-visibility: hidden;
    width: 100%;
    height: 100%;
  }

  & .front {
    background: url('${({front}) => front}') no-repeat;
    background-size: cover;
  }

  & .back {
    background: url('${({back}) => back}') no-repeat;
    background-size: cover;
    transform: rotateY(180deg);
  }
`;

const Card = props => (
  <Tap onTap={() => props.onSelect(props.card)} preventDoubleTap={false}>
    <CardWrapper {...props}
      className={classNames({
        selected: props.selected,
        discovered: props.discovered,
      })}
    >
      <div className="front" />
      <div className="back" />
    </CardWrapper>
  </Tap>
);

const TimerWrapper = styled.div`
  color: white;
  font-size: 130px;
  font-family: "zabaBold";
  padding: 40px 0;
  text-align: center;

  & .timer {
    display: inline-block;
  }
`;


function shuffle(o) {
  for(var j, x, i = o.length; i;
      j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
  return o;
}

export default class GameScreen extends Component {

  constructor(props) {
    super(props);

    const cards = [];
    for (let i=1; i <= 6; i++) cards.push(i, -i);
    shuffle(cards);

    this.state = {
      cards,
      started: false,
      ended: false,
      startTime: null,
      time: null,
      selected: [],
      discovered: [],
      moves: [],
    };

    this.revertCardTimeout = null;
    this.timeout = null;
  }

  componentDidMount() {
    this.timeout = setTimeout(() => this.props.gotoFirstScreen(), 6000);
  }

  render() {
    return (
      <Screen>
        <TimerWrapper>
          <Timer
            className="timer"
            time={45}
            started={this.state.started && !this.state.ended}
            onEnd={this.gameLost} />
          sec
        </TimerWrapper>
        <Cards>
          { this.getCards() }
        </Cards>
      </Screen>
    );
  }

  handleSelect = card => {
    const { selected, discovered, started, ended } = this.state;

    if (ended) return;
    if (selected.indexOf(card) !== -1 || discovered.indexOf(card) !== -1) return;

    const time = performance.now(),
          startTime = started ? this.state.startTime : time;

    if (!started) {
      clearTimeout(this.timeout);
      this.setState({started: true, startTime});
    }

    if (selected.length === 0) {
      this.setState({selected: [card]});
    } else if (selected.length === 1) {
      if (selected[0] + card === 0) {
        // found match
        let discovered = [...this.state.discovered, selected[0], card],
            ended = discovered.length === 12;

        this.setState(s => ({
          selected: [selected[0], card],
          discovered,
          ended,
          time: ended ? time - s.startTime : null,
          moves: [...s.moves, {card, time}],
        }));

        if (ended) setTimeout(this.gameWon, 1000);
      } else {
        this.setState(s => ({
          selected: [selected[0], card],
          moves: [...s.moves, {card, time}],
        }));
        this.revertCardTimeout = setTimeout(this.revertCards, 2000);
      }
    } else {
      this.setState(s => ({
        selected: [card],
        moves: [...s.moves, {card, time}],
      }));
      clearTimeout(this.revertCardTimeout);
    }
  }

  gameWon = () => {
    window.track('won', Object.assign({session: this.props.session}, this.state), true);
    this.props.update(s => ({...s, game: this.state}));
    this.props.gotoScreen('game_won');
  }

  gameLost = () => {
    this.setState({ended: true});

    setTimeout(() => {
      window.track('lost', this.state, true);
      this.props.gotoScreen('game_lost');
    }, 1000);
  }

  revertCards = () => {
    this.setState({selected: []});
  }

  getCards() {
    return this.state.cards.map(c => (
        <Card
          key={c}
          card={c}
          onSelect={this.handleSelect}
          discovered={this.state.discovered.indexOf(c) !== -1}
          selected={this.state.selected.indexOf(c) !== -1}
          front={CARDS[0]}
          back={CARDS[Math.abs(c)]}
          width="350px"
          height="350px"
          margin="5px"
        />
    ))
  }
}




// WEBPACK FOOTER //
// ./src/screens/GameScreen.js